import { FitParameter } from '@/components/Fit/measurements'

let nodeFilters = [
  {
    id: 1,
    name: 'Silhouette',
    options: [
      {
        id: 1,
        isSelected: false,
        name: 'Straight',
      },
      {
        id: 2,
        isSelected: false,
        name: 'Pencil',
      },
      {
        id: 3,
        isSelected: false,
        name: 'Tent',
      },
      {
        id: 4,
        isSelected: false,
        name: 'Cocoon',
      },
      {
        id: 5,
        isSelected: false,
        name: 'A-line',
      },
    ],
  },
  {
    id: 2,
    name: 'Fabric type',
    options: [
      {
        id: 1,
        isSelected: false,
        name: 'Woven',
      },
      {
        id: 2,
        isSelected: false,
        name: 'Knits',
      },
    ],
  },
  {
    id: 3,
    name: 'Waist seam',
    options: [
      {
        id: 1,
        isSelected: false,
        name: 'No waist',
      },
      {
        id: 2,
        isSelected: false,
        name: 'Natural waist',
      },
      {
        id: 3,
        isSelected: false,
        name: 'Empire waist',
      },
      {
        id: 4,
        isSelected: false,
        name: 'High waist',
      },
    ],
  },
  {
    id: 4,
    name: 'Closure',
    options: [
      {
        id: 1,
        isSelected: false,
        name: 'Surplice',
      },
      {
        id: 2,
        isSelected: false,
        name: 'Button down placket',
      },
      {
        id: 3,
        isSelected: false,
        name: 'Front zipper',
      },
      {
        id: 4,
        isSelected: false,
        name: 'Front seam',
      },
      {
        id: 5,
        isSelected: false,
        name: 'Button down',
      },
      {
        id: 6,
        isSelected: false,
        name: 'No seam',
      },
    ],
  },
]

let elementFabrics = [
  {
    id: 1,
    name: 'Wool',
  },
  {
    id: 2,
    name: 'Cotton',
  },
]

let technicalSketchOptions = [
  {
    id: 1,
    name: 'Woven',
  },
  {
    id: 2,
    name: 'No waist seam',
  },
  {
    id: 3,
    name: 'Above knee',
  },
  {
    id: 4,
    name: 'Straight',
  },
  {
    id: 5,
    name: 'Bust and waist darts',
  },
  {
    id: 6,
    name: 'No seam',
  },
]

const logo = '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 159.82 57.24"><defs><style>.cls-1{fill:#a7a9ac;}.cls-2{fill:#231f20;}</style></defs><polygon class="cls-1" points="112.69 31.89 159.82 3.94 159.82 57.24 112.69 31.89"/><path class="cls-2" d="M37.8,53.74V49.66h-.13a9.82,9.82,0,0,1-4.31,3.68,14,14,0,0,1-5.94,1.28,13.92,13.92,0,0,1-6.29-1.38,14.46,14.46,0,0,1-4.68-3.68,16.12,16.12,0,0,1-2.92-5.31,19.78,19.78,0,0,1-1-6.29,18.93,18.93,0,0,1,1-6.25,16.27,16.27,0,0,1,3-5.25A13.79,13.79,0,0,1,27.3,21.55a11.92,11.92,0,0,1,5.84,1.32,12.84,12.84,0,0,1,3.71,2.9H37V6.21H47.29V53.74ZM37.42,38a8.64,8.64,0,0,0-2.05-5.54A7.54,7.54,0,0,0,33,30.67,7,7,0,0,0,29.87,30a7.08,7.08,0,0,0-3.2.69A7.18,7.18,0,0,0,22.93,35a9.3,9.3,0,0,0-.48,3,9.59,9.59,0,0,0,.48,3,7.58,7.58,0,0,0,1.41,2.61,7,7,0,0,0,5.53,2.51A7,7,0,0,0,33,45.38a7.54,7.54,0,0,0,2.35-1.82A8.23,8.23,0,0,0,36.88,41,8.36,8.36,0,0,0,37.42,38Z" transform="translate(-12.52 -6.21)"/><path class="cls-2" d="M65.37,12.44a5.4,5.4,0,0,1-.47,2.23,5.58,5.58,0,0,1-1.26,1.79,5.75,5.75,0,0,1-1.88,1.19,6,6,0,0,1-2.3.44,5.76,5.76,0,0,1-4.21-1.66,5.4,5.4,0,0,1-1.7-4A5.54,5.54,0,0,1,54,10.27a5.06,5.06,0,0,1,1.26-1.8,6.6,6.6,0,0,1,1.89-1.22,5.56,5.56,0,0,1,2.32-.47,6,6,0,0,1,2.3.44,5.75,5.75,0,0,1,1.88,1.19A5.58,5.58,0,0,1,64.9,10.2,5.45,5.45,0,0,1,65.37,12.44ZM54.31,53.74V22.43H64.62V53.74Z" transform="translate(-12.52 -6.21)"/><path class="cls-2" d="M83.08,30.17V42.11a5.38,5.38,0,0,0,.85,3.3,3.63,3.63,0,0,0,3,1.1,11.65,11.65,0,0,0,1.61-.12A5.31,5.31,0,0,0,90,46l.13,7.55a17.65,17.65,0,0,1-2.71.66,20.05,20.05,0,0,1-3.27.28,15.3,15.3,0,0,1-5.28-.79,8.09,8.09,0,0,1-3.43-2.26,8.87,8.87,0,0,1-1.85-3.52A16.94,16.94,0,0,1,73,43.37V30.17H68V22.43h5V14.2H83.08v8.23h7.36v7.74Z" transform="translate(-12.52 -6.21)"/><path class="cls-2" d="M107.42,30.17V42.11a5.31,5.31,0,0,0,.85,3.3,3.61,3.61,0,0,0,3,1.1,11.54,11.54,0,0,0,1.61-.12,5.31,5.31,0,0,0,1.41-.38l.13,7.55a17.65,17.65,0,0,1-2.71.66,20.05,20.05,0,0,1-3.27.28,15.3,15.3,0,0,1-5.28-.79,8.11,8.11,0,0,1-3.42-2.26,8.89,8.89,0,0,1-1.86-3.52,17,17,0,0,1-.56-4.56V30.17h-5V22.43h5V14.2h10.13v8.23h7.35v7.74Z" transform="translate(-12.52 -6.21)"/><path class="cls-2" d="M151.81,38a17,17,0,0,1-1.39,6.95,15.47,15.47,0,0,1-3.77,5.28,17.3,17.3,0,0,1-5.53,3.37,19.54,19.54,0,0,1-13.43,0,16.87,16.87,0,0,1-5.53-3.37,15.66,15.66,0,0,1-3.74-5.28A16.94,16.94,0,0,1,117,38a16.72,16.72,0,0,1,1.38-6.91,15.42,15.42,0,0,1,3.74-5.22,16.15,16.15,0,0,1,5.53-3.27,20.52,20.52,0,0,1,13.43,0,16.54,16.54,0,0,1,5.53,3.27,15.23,15.23,0,0,1,3.77,5.22A16.72,16.72,0,0,1,151.81,38Zm-9.94,0a9,9,0,0,0-.5-3,7.91,7.91,0,0,0-1.45-2.55,7.39,7.39,0,0,0-2.32-1.79,7.81,7.81,0,0,0-6.42,0,7,7,0,0,0-2.29,1.79A7.78,7.78,0,0,0,127.5,35a9.52,9.52,0,0,0,0,5.91,8.28,8.28,0,0,0,1.42,2.61,7,7,0,0,0,2.33,1.85,7.79,7.79,0,0,0,6.41,0A6.91,6.91,0,0,0,140,43.53a8.08,8.08,0,0,0,1.42-2.61A9.64,9.64,0,0,0,141.87,38Z" transform="translate(-12.52 -6.21)"/></svg>'

const fetchSewingInstructions = async function () {
  return [
    {
      'id': '4301',
      'description': 'Sew. Instructions: Step 1.0',
      'content': 'Sewing Darts\n\n- Stitch bust and waist darts on the Front and Backs, starting from the center of the dart and stitching toward points of darts. \n- Knot ends of thread at points of darts. \n- Press bust darts down, press waist darts toward front and back center.',
      'step': '1',
      'element_id': '800',
      'element_type': null,
      'images': [
        {
          'instruction_id': '4301',
          'image_path': '',
          'airtable_url': 'https://dl.airtable.com/QdbFlNbpTjuACFIx2qJZ_WDR11001.png',
        }],
    },
    {
      'id': '4305',
      'description': 'Sew. Instructions: If No Waist Seam+par7=0 then Step 2.0',
      'content': 'Step 2. Sewing Center Back with A Kick Pleat (Vent)\n\n- On the wrong side of the garment mark the hemline with tailor\'s chalk. \n- Apply fusible interfacing to the wrong side of the vent on both sides, as shown on the diagram. Mark center seam line (vent\'s fold line) on the wrong side of the right edge.\n- Note: usually, the vent\'s left side overlaps the right.\n- Trim off the vent\'s seam allowance on the left side. Press left side along vent’s fold line onto the wrong side, then press right side along vent’s fold line onto the wrong side.\n- Separately overlock each side of the center back seam. Overlock seam allowances of the vent separately.\n- Overlock or finish the hem all the way around.\n- Cut a 2 1⁄2 inch wide fusible interfacing strips and fuse them around the circumference of the hem’s wrong side along the marked hemline (overlapping with the interfaced vent\'s extensions), placing the interfacing 2" above the hemline and 1⁄2 inch extending below the hemline. \n\nFor reference see Vent Preparation Image.\n\nFor center back zipper: \n- First, Install and Invisible zipper as described in Step 5.\n- After the zipper has been installed, start sewing the vent by stitching the center back seam from zipper notch down to vent\'s upper corner and back stitch at the beginning and the end of the seam.\n\nFor side seam zipper: \n- Stitch center back seam from the neck down to vent\'s corner and back stitch at the beginning and the end of the seam.\n\nFor both zipper options:\n- Press center back seam open.\n- Press vent\'s seam allowance on the left edge of the vent extension onto the wrong side and stitch.\n-  Trim off seam allowances on the right edge and finish the edge.\n- Press vent\'s extensions to the wrong side along the Vent\'s Fold Lines.\n- Turn the hem up once along the hemline and press.\n- Fold the vent\'s extensions onto the wrong side, along the Vent\'s Fold Lines over the pressed hemline and press again.\n-  Unfold extension\'s right side\'s seam allowance, then stitch along the vertical fold line joining the hem allowance and the extension together along the vertical line at a 1⁄4-inch from the edge. Press the seam open (you can use point presser). \n-Turn the hem allowance right side out, exposing a clean vertical edge, then press.\n-Turn the vent\'s left side\'s underlap extension out along the fold line, right sides together with the skirt. \n- Stitch along the hemline horizontally from the vent\'s outer edge to the end of the extension, to join the extension and the skirt. Trim below the overlap\'s seamline at 1/2 from the stitching line. Press the seam open with a point presser, and turn the hem allowance right side out.\n- Stitch along the upper diagonal edge of the vent\'s extensions, joining the left and right extensions and secure the vent in place.\n - Curve the stitch at the corner instead of a sharp pivot for a more secure vent. \n- Clip into the corner.\n- Fold the vent\'s extension along the seam line and press. On the inside, the vent\'s left underlap should lie flat. \n- Turn the hem up all the way around, following the pressed edges at the left side of the kick pleat. Press the hem and pin in place.\n\nSee Back Vent With Center Back Zipper Image below.',
      'step': '2',
      'element_id': '800',
      'element_type': null,
      'images': [
        {
          'instruction_id': '4305',
          'image_path': '',
          'airtable_url': 'https://dl.airtable.com/6AMpxwlnTb22h3wycs42_vent.png',
        },
        {
          'instruction_id': '4305',
          'image_path': '',
          'airtable_url': 'https://dl.airtable.com/xRGuw5lAScut2skacHKB_VentCenterBackZipper.png',
        },
        {
          'instruction_id': '4305',
          'image_path': '',
          'airtable_url': 'https://dl.airtable.com/VWzQtd7Q0KTGE0eNNAmR_vent.png',
        }],
    },
  ]
}

const fetchMeasures = async function (withAdditional = false) {
  let measures = [
    new FitParameter('height', 'Height', 1, 215, 175, false, undefined, 'cm'),
    new FitParameter('bust', 'Bust circumference', 1, 200, 140.75, false, undefined,
      'cm'),
    new FitParameter('bust_under', 'Under bust circumference', 1, 200, 83.37, false,
      undefined, 'cm'),
    new FitParameter('waist', 'Waist circumference', 1, 200, 76, false, undefined,
      'cm'),
  ]
  if (withAdditional) {
    measures = measures.concat([
      new FitParameter('upper_arm', 'Upper arm circumference', 1, 200, 34.87, true,
        undefined),
      new FitParameter('hips', 'Hips circumference', 1, 200, 105.28, true,
        undefined),
    ])
  }

  return measures
}

const fetchMeasuresBySize = async function (size, withAdditional = false) {
  return fetchMeasures(withAdditional)
}

const fetchMeasuresByMannequinId = async function (mannequinId, withAdditional = false) {
  return fetchMeasures(withAdditional)
}

export {
  nodeFilters,
  elementFabrics,
  technicalSketchOptions,
  logo,
  fetchSewingInstructions,
  fetchMeasures,
  fetchMeasuresBySize,
  fetchMeasuresByMannequinId,
}
